import Pagination from "@/components/share/pagination";
import Service from "../../../../utils/api/service";
import Helper from "../../../../utils/global/func";
import TableLoading from "../../../../components/share/table-loading";
import NoItem from "./../../../../components/share/table-no-item";
import { mapState } from "vuex";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "ListQuotation",
  data() {
    return {
      isFetching: true,
      isNoData: false,
      data: {
        order: [],
        pagination: {
          limit: 10,
          page: 1,
          total: 0,
          totalPage: 0,
        },
      },
      search: {
        accountId: "",
        transactionNumber: "",
        paymentStatus: "",
        cardCode: "",
        dateRange: "",
      },
    };
  },
  components: {
    Pagination,
    TableLoading,
    NoItem,
    DatePicker,
  },
  created() {
    this.setParams();
    this.getQuotations();
  },
  watch: {
    "$route.fullPath": function () {
      this.setParams();
      this.getQuotations();
    },
  },
  computed: {
    ...mapState(["permissions"]),
  },
  mounted() {},
  methods: {
    setParams() {
      const query = this.$route.query;
      this.search = this.$helper.setParams(this.search, query);

      if (query.startDate && query.endDate) {
        this.search.dateRange = [query.startDate, query.endDate];
      } else {
        this.search.dateRange = [];
      }
    },

    checkoutPermission(permissionName) {
      if (this.permissions) {
        let result = false;
        this.permissions.find((item) => {
          item.permissions.find((permission) => {
            if (permission.name == permissionName) {
              result = true;
            }
          });
        });

        return result;
      }
    },

    async searching() {
      let query = this.$helper.filterKeyMapping({
        limit: 10,
        page: 1,
        ...this.search,
      });
      await this.$router.push({ query }).catch(() => {});
    },

    getQuotations() {
      this.isFetching = true;
      let query = this.$root.$route.query;
      let setQuery = this.$helper.filterKeyMapping({
        page: query?.page || 1,
        ...query,
      });
      let params = this.$helper.queryParam(setQuery);

      Service.getQuotation(params).then((response) => {
        this.isFetching = false;
        if (response?.statusCode) {
          if (response?.statusCode === "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.getQuotations();
              }
            });
          } else if (response?.statusCode === "403") {
            this.isNoData = true;
            this.data.order = [];
            this.$toasted.show(response?.message);
          } else {
            this.$toasted.show(response?.message);
          }
        } else {
          if (response.data && response.data.length > 0) {
            this.isNoData = false;
            this.data.order = response?.data;
            this.data.pagination = Helper.calculatePagination(response?.meta);
          } else {
            this.data.order = [];
            this.isNoData = true;
            this.resetPagination();
          }
        }
      });
    },

    viewOrder(id) {
      let object = {
        id: id,
        page: this.$root.$route.query.page,
        accountId: this.search.accountId,
        transactionNumber: this.search.transactionNumber,
      };
      if (this.search.accountId == "") {
        delete object.accountId;
      }
      if (this.search.transactionNumber == "") {
        delete object.transactionNumber;
      }
      this.$router.push({ name: "EditOrder", query: object });
    },

    resetPagination() {
      this.data.pagination = {
        limit: 10,
        page: 1,
        total: 0,
        totalPage: 0,
      };
    },

    getFullImage(path) {
      return Helper.getFullImage(path);
    },
  },
};
